// extracted by mini-css-extract-plugin
export default {"contentWrapperTopPadding":"6em","mediumGrey":"#777","ProjectScreenHeaderHeight":"60px","defaultFontFamily":"\"Roboto\",Arial,sans-serif","SectionName":"styles_SectionName__P8bF5"};